import { axiosInstance } from "./config";

export const logClientAction = (action, module, metadata = {}) => {
  return axiosInstance.post("/logs/client", {
    action,
    module,
    metadata,
  });
};

export const getDailySummary = (date) => {
  return axiosInstance.get(`/logs/daily-summary?date=${date}`);
};

export const getCenterSummary = (date) => {
  return axiosInstance.get(`/logs/center-summary?date=${date}`);
};

export const getCenterLogs = (branchId, date) => {
  return axiosInstance.get(`/logs/center/${branchId}?date=${date}`);
};

export const getCandidateLogs = (candidateId) => {
  return axiosInstance.get(`/logs/candidate/${candidateId}`);
};

export const getOcrSummary = (date) => {
  return axiosInstance.get(`/logs/ocr-summary?date=${date}`);
};

export const triggerManualReport = (date) => {
  return axiosInstance.get(`/logs/test-report-trigger?date=${date}`);
};

